const Types = {
  SET_FB_AUTH_STATE: '@facebook-messenger/SET_FB_AUTH_STATE',
  SET_FB_SELECTED_PAGE: '@facebook-messenger/SET_FB_SELECTED_PAGE',
  SET_FB_CHANNEL_DATA: '@facebook-messenger/SET_FB_CHANNEL_DATA',
  SET_FB_IS_LOGGED: '@facebook-messenger/SET_FB_IS_LOGGED',
};

export default Types;
